<template lang="html">
  <div id="app-menu">
    <div class="menu-btn">
      <!-- Close button -->
      <button @click="toggleMenu()">
        <transition name="fade" mode="out-in">
          <i class="material-icons" key="open" v-if="menuOpen">close</i>
          <i class="material-icons" key="close" v-else>menu</i>
        </transition>
      </button>
    </div>

    <transition name="fade" mode="out-in">
      <div class="menu" v-if="menuOpen">
        <!-- Logo -->
        <div class="menu-logo">
          <img src="/static/the_keeley-logo.png" />
        </div>
        <!-- Menu items -->
        <ul @click="toggleMenu()">
          <router-link tag="li" to="/">3D &amp; Floorplan</router-link>
          <router-link tag="li" to="/Amenities">Amenities</router-link>
          <router-link tag="li" to="/Gallery">Gallery</router-link>
        </ul>
      </div>
    </transition>

  </div>
</template>

<script>
export default {
  name: 'app-menu',
  data() {
    return {
      menuOpen: false
    };
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    }
  }
};
</script>

<style lang="scss">
#app-menu {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 998;

  button {
    position: relative;
    background: transparent;
    border: none;
    padding: 1.25rem;
    cursor: pointer;
    z-index: 2;
    i.material-icons {
      font-size: 2.25rem;
    }
  }

  .menu {
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #bceffa;
    z-index: 1;

    .menu-logo {
      position: absolute;
      top: 3rem;
      left: 0;
      width: 100%;
      text-align: center;
      img {
        max-width: 16rem;
      }
    }

    ul {
      display: inline-block;
      list-style-type: none;
      padding: 0;
      margin: 0;

      li {
        cursor: pointer;
        padding: 3rem 0;
        font-size: 2.25rem;
        font-family: 'FuturaLTW01-Bold';
        @media (max-width: 1024px) {
          padding: 1.75rem 0;
          font-size: 1.6rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue